import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const config = {
    apiKey: "AIzaSyAlfSdlM1T9xmhF-AffQTjumggdrpHSNVY",
    authDomain: "pantry-907e9.firebaseapp.com",
    projectId: "pantry-907e9"
};
firebase.initializeApp(config);

// Export a reference to the database service
firebase.firestore().enablePersistence()
    .catch(function(err) {
        if (err.code === 'failed-precondition') {
            // Multiple tabs open, persistence can only be enabled
            // in one tab at a a time.
            console.log("Couldn't enable Firebase offline persistence - precondition failed");
        } else if (err.code === 'unimplemented') {
            // The current browser does not support all of the
            // features required to enable persistence
            console.log("Current browser doesn't support Firebase offline persistence");
        } else {
            console.log("There's a Firebase persistence error" + err);
        }
    });

export const database = firebase.firestore();

export function onAuthStateChanged(setActiveUser, setCheckedSignInState) {
    return firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            // user is signed in
            setActiveUser(user);
        } else {
            setActiveUser(undefined);
        }

        setCheckedSignInState(true);
    });
}